import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { QueryPatternView } from "./QueryPatternView";
import { QueryPatternViewStore } from "../../store/QueryPatternViewStore";
import { useStore } from "../../../../hooks";

export const QueryPatternViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/queryPattern/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new QueryPatternViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <QueryPatternView queryPatternViewStore={store} />
      </PageLayout>
    </div>
  );
});
